<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>{{this.dealerDetails.name}}</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>
      </div>

      <nav ngbNav #nav="ngbNav" (navChange)="changeTab($event)" class="grey-tab">
        <!--DealerInformation-->
        <ng-container [ngbNavItem]="0">
          <a ngbNavLink translate>
            <span translate>lblDealerInformation</span>
          </a>
          <ng-template ngbNavContent>
            <form [formGroup]="addDealerForm">
              <div class="card-accord scrollbar longtab">
                <div class="card p-0">
                  <div class="cst-acc-card mb20">
                    <div class="row">
                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="name" translate>lblDealerName <span class="text-danger">*</span></label>
                        <div class="lbl-info">
                          <input formControlName="name" class="form-control mb-2" maxlength="30"
                            [ngClass]="{'is-invalid': (cpf.name.touched || cpf.name.dirty) && cpf.name.errors}"
                            placeholder="Enter Name">
                          <div *ngIf="(cpf.name.touched || cpf.name.dirty) && cpf.name.errors">
                            <div *ngIf="cpf.name.errors.required" class="help-block mt-1 text-danger" translate>
                              lblDealerNameRequired</div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="service" translate>lblCompanyNumber <span class="text-danger" *ngIf="!isMg">*</span></label>
                        <div class="lbl-info">
                          <input type="text" formControlName="companyNumber" class="form-control"
                            placeholder="{{ 'lblEnterCompanyNumber' | translate }}" [required]="!isMg"
                            [ngClass]="{'is-invalid': cpf.companyNumber.invalid && cpf.companyNumber.touched}">
                          <div
                            *ngIf="cpf.companyNumber.invalid && (cpf.companyNumber.dirty || cpf.companyNumber.touched)"
                            class="help-block text-danger">
                            <div *ngIf="cpf.companyNumber.errors.required" class="help-block mt-1 text-danger"
                              translate>
                              lblCompanyNumberRequired
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group" *ngIf="isShowLocationCode">
                        <label for="DealershipsId" translate>lblDealershipsId <span class="text-danger">*</span></label>
                        <div class="lbl-info">
                          <input formControlName="dealershipsId" class="form-control"
                            placeholder="{{ 'lblEnterDealershipsId' | translate }}" maxlength="150" readonly>
                          <div
                            *ngIf="(cpf.dealershipsId.touched || cpf.dealershipsId.dirty) && cpf.dealershipsId.errors">
                            <div *ngIf="cpf.dealershipsId.errors.required" class="help-block mt-1 text-danger"><span
                                translate>lblDealershipsIdRequired</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="FranchiseId" translate>lblFranchiseId </label>
                        <div class="lbl-info">
                          <input formControlName="franchiseId" maxlength="15" id="FranchiseId"
                            (keypress)="isDigit($event)" class="form-control mb-2" placeholder="Enter FranchiseId">
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="FranchiseId"><span translate>lblVATNumber</span><span class="text-danger" *ngIf="!isMg"> * </span>
                        </label>
                        <div class="lbl-info">
                          <input formControlName="vatNumber" maxlength="20" id="vatNumber"
                            [ngClass]="{'is-invalid': (cpf.vatNumber.touched || cpf.vatNumber.dirty) && cpf.vatNumber.errors}"
                            class="form-control mb-2" placeholder="{{ 'lblEnterVATNumber' | translate }}">
                          <div *ngIf="(cpf.vatNumber.touched || cpf.vatNumber.dirty) && cpf.vatNumber.errors">
                            <div *ngIf="cpf.vatNumber.errors.required" class="help-block mt-1 text-danger" translate>
                              lblVATNumberRequired
                            </div>
                          </div>
                        </div>
                      </div>
                      <div hidden="true" class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="bankAccountNumber" translate>lblBankAccountNumber</label>
                        <div class="lbl-info">
                          <input formControlName="bankAccountNumber" id="bankAccountNumber" class="form-control mb-2"
                            [ngClass]="{'is-invalid': (cpf.bankAccountNumber.touched || cpf.bankAccountNumber.dirty) && cpf.bankAccountNumber.errors}"
                            placeholder="{{ 'lblEnterBankAccountNumber' | translate }}" maxlength="30">
                          <div
                            *ngIf="(cpf.bankAccountNumber.touched || cpf.bankAccountNumber.dirty) && cpf.bankAccountNumber.errors"
                            class="help-block mt-1 text-danger" translate>
                            lblInvallidBankAccountNumber
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="service" translate>lblCustomerWaitingLimit <span
                            class="text-danger">*</span></label>
                        <div class="lbl-info">
                          <input type="text" formControlName="customerWaitingLimit" class="form-control"
                            placeholder="Enter number" pattern="^[0-9]*$" required maxlength="4"
                            [ngClass]="{'is-invalid': cpf.customerWaitingLimit.invalid && cpf.customerWaitingLimit.touched}">
                          <div
                            *ngIf="cpf.customerWaitingLimit.invalid && (cpf.customerWaitingLimit.dirty || cpf.customerWaitingLimit.touched)"
                            class="help-block text-danger">
                            <div *ngIf="cpf.customerWaitingLimit.errors.required"><span
                                translate>lblCustomerWaitingLimitRequired</span></div>
                            <div *ngIf="cpf.customerWaitingLimit.errors.pattern"><span translate>lblProperValue</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="SsmDealerId" translate>lblSsmDealershipsId</label>
                        <div class="lbl-info">
                          <input formControlName="SsmDealerId" class="form-control"readonly>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="SstDealerId" translate>lblSstDealershipsId</label>
                        <div class="lbl-info">
                          <input formControlName="SstDealerId" class="form-control" readonly>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="cst-acc-card mb20">
                    <div class="row">
                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="address1" translate>lblAddressLine1 <span class="text-danger">*</span></label>
                        <div class="lbl-info">
                          <input formControlName="address1" class="form-control mb-2" maxlength="150"
                            [ngClass]="{'is-invalid': (cpf.address1.touched || cpf.address1.dirty) && cpf.address1.errors}"
                            placeholder="Enter Address Line 1">
                          <div *ngIf="(cpf.address1.touched || cpf.address1.dirty) && cpf.address1.errors">
                            <div *ngIf="cpf.address1.errors.required" class="help-block mt-1 text-danger" translate>
                              lblAddressLine1Required</div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="address2" translate>lblAddressLine2</label>
                        <div class="lbl-info">
                          <input formControlName="address2" class="form-control" placeholder="Enter Address Line 2"
                            maxlength="150">
                        </div>
                      </div>
                      <div class="col-lg-6 col-xl-3 af-form-group">
                        <label for="pincode"><span translate>lblPostCode</span> <span class="text-danger"> * </span>
                        </label>
                        <div class='lbl-info'>
                          <ng-select formControlName="pincode" placeholder="{{ 'lblSelectPostCode' | translate }}"
                            required [virtualScroll]="true" (change)="onPostCodeSelected($event)"
                            [ngClass]="{'ng-select-is-invalid':(cpf.pincode.invalid  && cpf.pincode.touched) || (cpf.pincode.invalid  && isFormValid)}">
                            <ng-option *ngFor="let item of postCodeList" [value]="item.code">
                              {{item.code}}</ng-option>
                          </ng-select>
                          <div
                            *ngIf="(cpf.pincode.invalid && (cpf.pincode.dirty || cpf.pincode.touched)) || (cpf.pincode.invalid && isFormValid)"
                            class="help-block text-danger">
                            <div *ngIf="cpf.pincode.errors.required"><span translate>lblRequiredPostCode</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-xl-3 af-form-group">
                        <label for="city"><span translate>lblCity</span><span class="text-danger"> * </span>
                        </label>
                        <div class='lbl-info'>
                          <ng-select formControlName="city" placeholder="{{ 'lblSelectCity' | translate }}" required
                            (change)="onCitySelected($event)"
                            [ngClass]="{'ng-select-is-invalid':(cpf.city.invalid  && cpf.city.touched) || (cpf.city.invalid  && isFormValid)}">
                            <ng-option *ngFor="let item of cityList" [value]="item">
                              {{item}}</ng-option>
                          </ng-select>
                          <div
                            *ngIf="(cpf.city.invalid && (cpf.city.dirty || cpf.city.touched)) || (cpf.city.invalid && isFormValid)"
                            class="help-block text-danger">
                            <div *ngIf="cpf.city.errors.required"><span translate>lblRequiredCity</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="country" translate>lblCountry <span class="text-danger">*</span></label>
                        <div class="lbl-info">
                          <select formControlName="country"
                            [ngClass]="{'is-invalid': (cpf.country.touched || cpf.country.dirty) && cpf.country.errors}"
                            class="custom-select custom-select mb-2">
                            <option disabled value="-1">Select Country</option>
                            <option *ngFor="let country of countryList" [value]="country.id">
                              {{country.countryName}}</option>
                            <div *ngIf="(cpf.country.touched || cpf.country.dirty) && cpf.country.errors">
                              <div *ngIf="cpf.country.errors.required || cpf.country.errors.NotSelected"
                                class="help-block mt-1 text-danger" translate>
                                lblCountryRequired
                              </div>
                            </div>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="landline" translate>lblLandline <span class="text-danger">*</span></label>
                        <div class="lbl-info">
                          
                          <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="landline" [cssClass]="{'form-control': true}"
                          [selectedCountryISO]="selectedCountryISOLandline" [maxLength]="15" [phoneValidation]="false"
                          [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="true"
                          [customPlaceholder]="'lblEnterLandline' | translate" (keyup)="onLandlineChange()"
                          (countryChange)="onCountryChangeForLandline($event)" (change)="landlineNumberChanged()"
                          ></ngx-intl-tel-input>
                          <div *ngIf="(cpf.landline.touched || cpf.landline.dirty) && cpf.landline.errors">
                            <div *ngIf="cpf.landline.errors.required" class="help-block mt-1 text-danger" translate>
                              lblLandlineRequired
                            </div>
                            <div *ngIf="cpf.landline.errors.pattern" class="help-block mt-1 text-danger" translate>
                              lblEnterValidLandline
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="mobile" translate>lblMobile</label>
                        <div class="lbl-info">
                          <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="mobile" [cssClass]="{'form-control': true}"
                          [selectedCountryISO]="selectedCountryISOMobile" [maxLength]="15" [phoneValidation]="false"
                          [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="true"
                          customPlaceholder="{{ 'lblEnterMobile' | translate }}" (keyup)="onMobileChange()"
                          (countryChange)="onCountryChange($event)" (change)="mobileNumberChanged()"
                          ></ngx-intl-tel-input>
                          <div *ngIf="(cpf.mobile.touched || cpf.mobile.dirty) && cpf.mobile.errors">
                            <div *ngIf="cpf.mobile.errors.pattern" class="help-block mt-1 text-danger" translate>
                              lblEnterValidMobile
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="email" translate>lblEmail <span class="text-danger">*</span></label>
                        <div class="lbl-info">
                          <input formControlName="email" class="form-control mb-2" maxlength="50"
                            [ngClass]="{'is-invalid': (cpf.email.touched || cpf.email.dirty) && cpf.email.errors}"
                            placeholder="Enter Email">
                          <div *ngIf="(cpf.email.touched || cpf.email.dirty) && cpf.email.errors">
                            <div *ngIf="cpf.email.errors.required" class="help-block mt-1 text-danger" translate>
                              lblEmailRequired
                            </div>
                            <div *ngIf="cpf.email.errors.pattern" class="help-block mt-1 text-danger" translate>
                              lblEnterValidEmail
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="cst-acc-card mb20" *ngIf="!isShowPriceInBrand || !isMg">
                    <div class="row">
                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group" *ngIf="!isShowPriceInBrand">
                        <label for="service" translate>lblLabourHourlyRate <span class="text-danger">*</span></label>
                        <div class="lbl-info">
                          <input formControlName="unitPrice" class="form-control mb-2" pattern="^[\d,.\s]+$"
                            maxlength="10" (change)="onChangeUnitPrice($event)" (keyup)="checkLength($event)" required>
                          <div *ngIf="cpf.unitPrice.touched && (cpf.unitPrice.errors?.required)"
                            class="help-block mt-1 text-danger" translate>
                            lblRateRequired
                          </div>
                          <div *ngIf="cpf.unitPrice.touched && (cpf.unitPrice.errors?.pattern) || isValidUnitPrice"
                            class="help-block mt-1 text-danger" translate>
                            lblProperValue
                          </div>
                          <div *ngIf="isUnitPriceLengthError" class="help-block mt-1 text-danger" translate> <em
                              class="ft-alert-circle align-middle" aria-hidden="true"></em>
                            lblRateUpto6digit
                          </div>
                        </div>
                      </div>
                      <div class="af-form-group" *ngIf="!isMg">
                        <div class="row pl-3">
                          <div class="col-12 af-form-group">
                            <div class="row">
                              <div class="af-form-group">
                                <label translate>lblTimeDeliveryOfCar</label>
                                <div class="lbl-info">
                                  <div class="d-flex align-items-center">
                                    <div class="date">
                                      <ngb-timepicker [(ngModel)]="deliveryTimeSlot" [ngModelOptions]="{standalone: true}"></ngb-timepicker>
                                    </div>
                                    <button type="button" class="btn btn-primary ml-2" ngbTooltip="{{'lblAdd' | translate}}" container="body"
                                      tooltipClass="custom-revert" (click)="onTimeSlotAdd()">
                                      <em class="fa fa-plus"></em>
                                    </button>
                                    <div>
                                      <div class="d-flex flex-wrap">
                                        <div *ngFor="let slot of configurationArrivalTimes">
                                          <div class="time-slot d-flex justify-content-center align-items-center">
                                            <span> {{slot.timeSlot}} </span>
                                            <em class="far fa-trash-alt fa-lg" ngbTooltip="{{'lblDelete' | translate}}" container="body"
                                              tooltipClass="custom-revert" (click)="onTimeSlotDelete(slot.timeSlot)"></em>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class='col-md-6 col-lg-6 col-xl-3 af-form-group '>
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                        <label class="custom-control-label" for="isActive" translate>lblActive</label>
                      </div>
                    </div>
                    <div class='col-md-6 col-lg-6 col-xl-3 af-form-group'>
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="isActiveForWidget"
                          formControlName="isActiveForWidget">
                        <label class="custom-control-label" for="isActiveForWidget"
                          translate>lblOnlineBookingWidget</label>
                      </div>
                    </div>
                    <div class='col-md-6 col-lg-6 col-xl-3 af-form-group'>
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="onlinePayment"
                          formControlName="onlinePayment">
                        <label class="custom-control-label" for="onlinePayment" translate>lblonlinePayment</label>
                      </div>
                    </div>
                    <div class='col-md-6 col-lg-6 col-xl-3 af-form-group mt-lg-3 mt-xl-0' *ngIf="isPickUpDropOff">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="vehiclePickupDropoffService"
                          formControlName="vehiclePickupDropoffService">
                        <label class="custom-control-label" for="vehiclePickupDropoffService"
                          translate>lblVehiclePickupAndDropoffService</label>
                      </div>
                    </div>

                    <div class='col-md-6 col-lg-6 col-xl-3 af-form-group' *ngIf="isShareBoxEnabled">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="keyLocation"
                          formControlName="keyLocation" (change)="showHideDealerSession()">
                        <label class="custom-control-label" for="keyLocation" translate
                          >lblSharebox</label>
                        </div>
                    </div>

                    <div class="col-lg-6 col-xl-3 af-form-group" *ngIf="showDealerSession">
                      <label for="dealerSessionId"><span translate>lblShareBoxSessionId <span
                            class="text-danger">*</span></span>
                      </label>
                      <div class="lbl-info" *ngIf="isDealerSessionIdSet">
                        <input type="text" formControlName="dealerSessionId" id="dealerSessionId" readonly
                          class="form-control" />
                      </div>
                      <div class="lbl-info" *ngIf="!isDealerSessionIdSet">
                        <input formControlName="dealerSessionId" id="dealerSessionId" class="form-control mb-2"
                          [ngClass]="{'is-invalid': (cpf.dealerSessionId.touched || cpf.dealerSessionId.dirty) && cpf.dealerSessionId.errors}"
                          placeholder="{{ 'lblEnterShareBoxSessionId' | translate }}"
                          (keyup)="validateDealerSessionId()">
                        <div
                          *ngIf="((cpf.dealerSessionId.touched || cpf.dealerSessionId.dirty) && cpf.dealerSessionId.errors) || isDealerSessionIdError"
                          class="help-block mt-1 text-danger" translate>
                          lblInvallidDealerSessionId
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-xl-3 af-form-group" *ngIf="showDealerSession">
                      <label for="dealerDropInLink"><span translate>lblShareBoxDropInLink <span
                            class="text-danger">*</span></span>
                      </label>
                      <div class="lbl-info" *ngIf="isDealerSessionIdSet">
                        <input type="text" formControlName="dealerDropInLink" id="dealerDropInLink" readonly
                          class="form-control" />
                      </div>
                      <div class="lbl-info" *ngIf="!isDealerSessionIdSet">
                        <input formControlName="dealerDropInLink" id="dealerDropInLink" class="form-control mb-2"
                          [ngClass]="{'is-invalid': (cpf.dealerDropInLink.touched || cpf.dealerDropInLink.dirty) && cpf.dealerDropInLink.errors}"
                          placeholder="{{ 'lblEnterShareBoxSessionId' | translate }}"
                          (keyup)="validateDealerSessionId()">
                        <div
                          *ngIf="((cpf.dealerDropInLink.touched || cpf.dealerDropInLink.dirty) && cpf.dealerDropInLink.errors) || isDealerSessionIdError"
                          class="help-block mt-1 text-danger" translate>
                          lblInvallidDealerSessionId
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="cst-acc-card mb20 form-row" *ngIf="isMg">
                    <div class="col-lg-6 col-xl-3 af-form-group mt-3 d-flex align-items-center">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="kiosk"
                          formControlName="kiosk">
                        <label class="custom-control-label" for="kiosk"
                          translate>lblOlbKiosk</label>
                      </div>
                    </div>
                    <div class="col-lg-6 col-xl-3 af-form-group mt-3 d-flex align-items-center">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="enableMenuPricing"
                          formControlName="enableMenuPricing">
                        <label class="custom-control-label" for="enableMenuPricing"
                          translate>lblOlbEnableMenuPricing</label>
                      </div>
                    </div>
                    <div class="col-lg-6 col-xl-3 af-form-group mt-3 d-flex align-items-center">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="enableBookingNotification"
                          formControlName="enableBookingNotification">
                        <label class="custom-control-label" for="enableBookingNotification"
                          translate>lblOlbEnableBookingNotification</label>
                      </div>
                    </div>
                    <div class="col-lg-6 col-xl-3 af-form-group mt-3">
                      <label for="leadTime"><span translate>lblOlbLeadTime</span>
                      </label>
                      <div class="lbl-info">
                        <input type="number" class="form-control mb-2" id="leadTime" formControlName="leadTime">
                      </div>
                    </div>
                    <div class="col-lg-6 col-xl-3 af-form-group mt-3 d-flex align-items-center">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="enableDMS"
                          formControlName="enableDMS">
                        <label class="custom-control-label" for="enableDMS"
                          translate>lblOlbEnableDMS</label>
                      </div>
                    </div>
                    <div class="col-lg-6 col-xl-3 af-form-group mt-3 d-flex align-items-center">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="serviceAgreement"
                          formControlName="serviceAgreement">
                        <label class="custom-control-label" for="serviceAgreement"
                          translate>lblOlbServiceAgreement</label>
                      </div>
                    </div>
                    <div class="col-lg-6 col-xl-3 af-form-group mt-3 d-flex align-items-center">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="realTimeBooking"
                          formControlName="realTimeBooking">
                        <label class="custom-control-label" for="realTimeBooking"
                          translate>lblOlbRealTimeBooking</label>
                      </div>
                    </div>
                    <div class="col-lg-6 col-xl-3 af-form-group mt-3">
                      <label for="noOfWeekInCalendar"><span translate>lblOlbNoOfWeekInCalendar</span>
                      </label>
                      <div class="lbl-info">
                        <input type="number" class="form-control mb-2" id="noOfWeekInCalendar" formControlName="noOfWeekInCalendar">
                      </div>
                    </div>
                    <div class="col-lg-6 col-xl-3 af-form-group mt-3 d-flex align-items-center">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="isCampaignPriceConsidered"
                          formControlName="isCampaignPriceConsidered">
                        <label class="custom-control-label" for="isCampaignPriceConsidered"
                          translate>lblIsCampaignPriceConsidered</label>
                      </div>
                    </div>
                  </div>
                  <div class="cst-acc-card mb20 form-row" *ngIf="isMg">
                    <div class="col-lg-6 col-xl-3 py-4 af-form-group d-flex align-items-center">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="enableRentalCar"
                          formControlName="enableRentalCar">
                        <label class="custom-control-label" for="enableRentalCar"
                          translate>lblOlbEnableRentalCar</label>
                      </div>
                    </div>
                    <div class="col-lg-6 col-xl-3 af-form-group d-flex align-items-center" *ngIf="cpf.enableRentalCar.value">
                      <div class="col-auto d-flex flex-row">
                        <input type="radio" class="radio-custom" id="rentalProvider1" formControlName="rentalProvider" [value]="1">
                        <label class="form-check-label" for="rentalProvider1" translate>lblOlbOwnRentalCar</label>
                      </div>
                      <div class="col-auto d-flex flex-row">
                        <input type="radio" class="radio-custom" id="rentalProvider2" formControlName="rentalProvider" [value]="2">
                        <label class="form-check-label" for="rentalProvider2" translate>lblOlbThirdPartyRentalCar</label>
                      </div>
                    </div>
                    <div class="col-lg-6 col-xl-3 af-form-group" *ngIf="cpf.enableRentalCar.value && cpf.rentalProvider.value == 2">
                      <label for="rentalCarPrice"><span translate>lblOlbThirdPartyRentalCarPrice</span>
                      </label>
                      <div class="lbl-info">
                        <input type="number" class="form-control mb-2" id="rentalCarPrice" formControlName="rentalCarPrice">
                      </div>
                    </div>
                  </div>
                  <div class="row pl-3" *ngIf="isMg">
                    <div class="col-12 af-form-group">
                      <div class="row">
                        <div class="col-12 col-md-3">
                          <div class="af-form-group">
                            <label translate>lblTimeDeliveryOfCar</label>
                            <div class="lbl-info">
                                <div class="d-flex align-items-center">
                                    <div class="date">
                                      <ngb-timepicker [(ngModel)]="deliveryTimeSlot"
                                      [ngModelOptions]="{standalone: true}"></ngb-timepicker>
                                    </div>
                                    <button type="button" class="btn btn-primary ml-2" ngbTooltip="{{'lblAdd' | translate}}" container="body" tooltipClass="custom-revert" (click)="onTimeSlotAdd()">
                                      <em class="fa fa-plus"></em>
                                  </button>
                                </div>
                            </div>
                        </div>
                        </div>
                        <div class="col-12 col-md-9 d-flex align-items-center">
                          <div class="d-flex flex-wrap">
                            <div *ngFor="let slot of configurationArrivalTimes">
                              <div class="time-slot d-flex justify-content-center align-items-center">
                                <span> {{slot.timeSlot}} </span>
                                <em class="far fa-trash-alt fa-lg" ngbTooltip="{{'lblDelete' | translate}}" container="body" tooltipClass="custom-revert" (click)="onTimeSlotDelete(slot.timeSlot)"></em>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                    <div class="lbl-info">
                      <label translate>lblTransportation</label>
                      <ng-multiselect-dropdown [settings]="dropdownSettings" style="width: 100%" [data]="transportSolutionList" 
                        [(ngModel)]="selectedTransportSolutions" [ngModelOptions]="{standalone: true}"
                        placeholder="{{'lblTransportation'| translate}}" (onSelect)="onChangeTransportSolution($event,true,false)"
                        (onDeSelect)="onChangeTransportSolution($event,false,false)" (onSelectAll)="onAllTransportSolution(true)"
                        (onDeSelectAll)="onAllTransportSolution(false)">
                      </ng-multiselect-dropdown>
                    </div>
                  </div>
                </div>
              </div>

              <div class="p-3 bg-light pp-footer-top-brdr">
                <div class="row">
                  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb10 mt5">
                    <button class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align"
                      [disabled]="(addDealerForm.invalid || isUnitPriceLengthError || isValidUnitPrice ) || isDealerSessionIdError"
                      (click)="onSubmit(false)" translate>
                      <em class="far fa-save font16 align-top mr-2"></em> lblSaveChanges</button>
                    <button class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align"
                      [disabled]="(addDealerForm.invalid || isUnitPriceLengthError || isValidUnitPrice ) || isDealerSessionIdError"
                      (click)="onSubmit(true)" translate>
                      <em class="far fa-save font16 align-top mr-2"></em> lblSaveAndClose</button>
                    <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate><em
                        class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
                  </div>
                </div>
              </div>

            </form>
          </ng-template>
        </ng-container>


        <!--DealerBrands-->
        <ng-container [ngbNavItem]="2">
          <a ngbNavLink>
            <span translate>lblDealerBrands</span>
          </a>
          <ng-template ngbNavContent>
            <div class=" scrollbar longtab">
              <div class="card pad15">
                <div class="row pb-2">
                  <div class="col-sm-3">
                      <div class="relative flmid">
                          <div class="input-group flgrow">
                              <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearchByBrands' | translate }}" [(ngModel)]="pService.searchTerm" autocomplete="off" />
                              <div class="input-group-append">
                                  <button type="button" class="btn btn-primary">
                                      <em class="fa fa-search"></em>
                                  </button>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-auto ml-auto">
                    <button type="button" (click)="open(mymodal)" type="reset" aria-label="Center Align"
                      class="add-button btn btn-primary mr-sm-2 mb-1" translate>lblAddBrand</button>
                  </div>
              </div>
                <div *ngIf="dealerBrands">
                  <div class="table-responsive tableMx-15">
                    <table class="tablest1">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col" translate>lblLogo</th>
                          <th scope="col" sortable="brandName" (sort)="onSort($event)" translate>lblBrandName</th>
                          <th scope="col" sortable="brandCode" (sort)="onSort($event)" translate>lblBrandCode</th>
                          <th scope="col" translate>lblDescription</th>
                          <th scope="col" translate sortable="isDisplayInWidget" (sort)="onSort($event)">lblIsDisplayInWidget</th>
                          <th *ngIf="isShowPriceInBrand" scope="col" class="text-right" translate>lblPrice</th>
                          <th *ngIf="isShowPriceInBrand" scope="col" class="text-right" translate>lblPrice <span class="text-sm1" translate>lblInclVAT</span></th>
                          <th scope="col" style="width: 120px" class="text-center" translate>lblAction</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="dealerBrands?.length>0; else load_else">
                          <tr *ngFor="let dealerBrand of dealerBrands; let i=index">
                            <td>{{ dealerBrand.row }}</td>
                            <td>
                              <span class="imgWid" *ngIf="dealerBrand.brandCode">
                                <img width="40" class="brandicon" af-brand-logo [data-code]="dealerBrand.brandCode" data-type="BRAND" alt="brand logo" />
                              </span>
                            </td>
                            <td>
                              <ngb-highlight [result]="dealerBrand.brandName" [term]="pService.searchTerm"></ngb-highlight>
                            </td>
                            <td>
                              <ngb-highlight [result]="dealerBrand.brandCode" [term]="pService.searchTerm"></ngb-highlight>
                            </td>
                            <td>
                              <ngb-highlight [result]="dealerBrand.description" [term]="pService.searchTerm"></ngb-highlight>
                            </td>
                            <td>
                              <em class="fas fa-check fa-lg"*ngIf="dealerBrand.isDisplayInWidget === true"></em>
                              <em class="fas fa-times text-danger fa-lg cursordisable" *ngIf="dealerBrand.isDisplayInWidget === false"></em>
                            </td>
                            <td *ngIf="isShowPriceInBrand" class="text-right">{{dealerBrand.price | number: '1.2-2'}} </td>
                            <td *ngIf="isShowPriceInBrand" class="text-right">{{dealerBrand.priceInclVat | number: '1.2-2'}} </td>
                            <td class="nowrap text-center">
                              <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert"
                                (click)="openEdit(mymodal,dealerBrand)">
                                <em class="fas fa-pencil-alt fa-lg"></em>
                              </a>
                              <span class="ico-div"></span>
                              <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                                (click)="deleteBrand(dealerBrand)">
                                <em class="far fa-trash-alt fa-lg"></em>
                              </a>
                            </td>
                          </tr>
                        </ng-container>
                        <ng-template #load_else>
                          <tr>
                            <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                          </tr>
                        </ng-template>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="card-footer px-0 pb-0">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex justify-content-between">
                      <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                        [pageSize]="pService.pageSize" [maxSize]="3">
                      </ngb-pagination>
                      <select class="custom-select mx-2" style="width: auto" name="pageSize"
                        [(ngModel)]="pService.pageSize">
                        <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>
                          {{item.label}}
                        </option>
                      </select>
                    </div>
                    <div class="d-flex justify-content-between font17 fontbold" style="margin: auto 0;">
                      <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ |
                      async}}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-3 bg-light pp-footer-top-brdr">
              <ng-container>
                <div class="row">
                  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb10 mt5">
                    <a (click)="OnClose()" type="reset" class="btn btn-secondary  btn-lg" translate>
                      <em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
                  </div>
                </div>
              </ng-container>
            </div>



          </ng-template>
        </ng-container>

        <!--DealerHolidays-->
        <ng-container [ngbNavItem]="3">
          <a ngbNavLink translate>
            <span translate>lblDealerHolidays</span>
          </a>
          <ng-template ngbNavContent>
            <div class="form-group">
              <div *ngIf="dealerHolidayDetails">
                <div class=" scrollbar  longtab">
                  <div class="card pad15 pt-0">
                    <div class="table-responsive tableMx-15">
                      <table class="tablest1">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col" sortable="name" (sort)="onSort($event)" translate>lblHoliday</th>
                            <th scope="col" translate>lblStartDate</th>
                            <th scope="col" translate>lblEndDate</th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *ngIf="dealerHoliday?.length>0; else load_else">
                            <tr *ngFor="let dealerHoliday of dealerHoliday; let i=index">
                              <td>{{ dealerHoliday.rowNumber }}</td>
                              <td>
                                <ngb-highlight [result]="dealerHoliday.name" [term]="pService.searchTerm">
                                </ngb-highlight>
                              </td>
                              <td>{{dealerHoliday.startDate}}</td>
                              <td>{{dealerHoliday.endDate}}</td>
                            </tr>
                          </ng-container>
                          <ng-template #load_else>
                            <tr>
                              <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                            </tr>
                          </ng-template>
                        </tbody>
                      </table>
                    </div>
                    <div class="card-footer px-0 pb-0">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex justify-content-between">
                          <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                            [pageSize]="pService.pageSize" [maxSize]="3">
                          </ngb-pagination>
                          <select class="custom-select mx-2" style="width: auto" name="pageSize"
                            [(ngModel)]="pService.pageSize">
                            <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>
                              {{item.label}}
                            </option>
                          </select>
                        </div>
                        <div class="d-flex justify-content-between font17 fontbold" style="margin: auto 0;">
                          <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ |
                          async}}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="p-3 bg-light pp-footer-top-brdr">

                  <ng-container>
                    <div class="row">
                      <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb10 mt5">
                        <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg " translate>lblCancel</a>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>

        <!--DealerShiftDetails-->
        <ng-container [ngbNavItem]="4">
          <a ngbNavLink translate>
            <span translate>lblDealerShiftDetails</span>
          </a>
          <ng-template ngbNavContent>
            <app-edit-dealer-working-hours [dealerId]="dealerId">
            </app-edit-dealer-working-hours>
          </ng-template>
        </ng-container>

        <!--DealerTimeSlotDetails-->
        <ng-container [ngbNavItem]="5">
          <a ngbNavLink translate>
            <span translate>lblDealerTimeSlotDetails</span>
          </a>
          <ng-template ngbNavContent>
            <app-edit-dealer-customer-waiting-hours [dealerId]="dealerId">
            </app-edit-dealer-customer-waiting-hours>
          </ng-template>
        </ng-container>

        <!--TaxDetails-->
        <ng-container [ngbNavItem]="6" *ngIf="isShowTaxTab">
          <a ngbNavLink translate>
            <span translate>lblTaxDetails</span>
          </a>
          <ng-template ngbNavContent>
            <ng-container *ngIf="dealerId">
              <app-edit-tax-details [dealerId]="dealerId"></app-edit-tax-details>
            </ng-container>
          </ng-template>
        </ng-container>

      </nav>
      <div [ngbNavOutlet]="nav"></div>

    </div>
  </div>




</div>



<ng-template #mymodal let-modal>

  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>lblDealerBrand</h4>
    <button type="button" #closeModal id="modelButton" class="close" aria-label="Close"
      (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="">
      <form #f="ngForm" (ngSubmit)="AddBrand(AddBrandInfo)">
        <div class="row">
          <div class="col-12 af-form-group">
            <label for="template-edit-company" translate>lblBrandName <span class="required">*</span></label>
            <div class="lbl-info">
              <ng-select name="brandCode" #brandCode="ngModel" appendTo="body"
                [class.in-invalid]="brandCode.isvalid && brandCode.touched" required [disabled]="isBrandedit"
                [(ngModel)]="AddBrandInfo.brandCode" placeholder="{{ 'lblBrandName' | translate }}"
                [ngClass]="{'is-invalid': brandCode.invalid && brandCode.touched}">
                <ng-template ng-header-tmp>
                  <span class="mbold w-66px">Code</span>
                  <span class="mbold" translate>lblBrandName</span>
                </ng-template>
                <ng-option *ngFor="let brand of brandList" [value]="brand.brandCode">
                  <span class="w-66px">{{brand.brandCode}}</span>
                  <span class="mx-2 hide-ng-dropdown-panel">-</span>
                  <span>{{brand.brandName}}</span>
                </ng-option>
              </ng-select>
              
              <div *ngIf="brandCode.invalid && (brandCode.dirty || brandCode.touched)" class="help-block text-danger">
                <div *ngIf="brandCode.errors.required">
                  <span translate>lblCompanyRequired</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 af-form-group">
            <label for="template-edit-model" translate>lblDescription</label>
            <div class="lbl-info">
              <input type="text" id="template-edit-model" name="description" #description="ngModel" class="form-control"
                [(ngModel)]="AddBrandInfo.description" maxlength="100">
            </div>
          </div>
          <div class="col-12 af-form-group" *ngIf="isShowPriceInBrand">
            <label for="template-edit-model">Hourly <span class="text-sm1" translate>lblPrice</span> <span class="text-sm1" translate> lblExclVat</span> <strong class="mlt6 required"> * </strong></label>
            <div class="lbl-info">
               <input  pattern="^[\d,.\s]+$" name="price" #price="ngModel" class="form-control mb-2" maxlength="10" required
                  [(ngModel)]="AddBrandInfo.price" (blur)="onBlur($event)">
                  <div *ngIf="price.touched && (price.errors?.required)" class="help-block mt-1 text-danger"
                    translate>
                    lblPriceRequired
                  </div>
                  <div *ngIf="price.touched && (price.errors?.pattern)" class="help-block mt-1 text-danger"
                  translate>
                  lblOnlyNumbersAreAllowed
                </div>
            </div>
          </div>
          <div class="col-12 af-form-group" *ngIf="isShowPriceInBrand">
            <label for="template-edit-model" translate>Hourly <span class="text-sm1" translate>lblPrice</span> <span class="text-sm1" translate> lblInclVAT</span> <strong class="mlt6 required"> * </strong></label>
            <div class="lbl-info">
              <input type="text" id="template-edit-model" name="priceInclVat" #priceInclVat="ngModel" class="form-control"
                [(ngModel)]="AddBrandInfo.priceInclVat" maxlength="15" pattern="^[\d,.\s]+$" disabled>
            </div>
          </div>
          <div class="col-12 af-form-group d-flex">
            <label for="template-edit-company" translate>lblIsDisplayInWidget</label>
            <div class="custom-control custom-switch ml-4">
              <input type="checkbox" id="isDisplayInWidget" #isDisplayInWidget="ngModel" [(ngModel)]="AddBrandInfo.isDisplayInWidget" name="isDisplayInWidget" 
                class="custom-control-input">
              <label for="isDisplayInWidget" class="custom-control-label"></label>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <div class="d-flex flex-sm-row flex-column justify-content-end">
      <button type="submit" class="btn btn-primary" aria-label="Center Align" translate [disabled]="!f.valid"
        (click)="AddBrand(AddBrandInfo)">lblSaveChanges</button>
      <button (click)="modal.dismiss('Cross click')" aria-label="Center Align" class="btn btn-secondary ml-3"
        translate>lblCancel</button>
    </div>
  </div>
</ng-template>